export default __webpack_public_path__ + "static/media/Blog9.499f3256.png";